import React, { useCallback, useMemo } from 'react'

import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

import { ScrollZoneProps } from './ScrollZone.types'

import './ScrollZone.scss'
import { UseComboboxGetItemPropsOptions } from 'downshift'

const ScrollZone: React.FC<ScrollZoneProps> = ({ 
  isOpen,
  items,
  highlightedIndex,
  menuStyle,
  renderItem,
  getMenuProps,
  getItemProps,
  onScrollEnd
}) => {

  const menuProps = useMemo(() => {
    return getMenuProps ? getMenuProps() : {}
  }, [getMenuProps])

  const itemPropsFunc = useCallback((options: UseComboboxGetItemPropsOptions<{
      id: string;
      name: string;
      disabled?: boolean;
    }>) => {
    return getItemProps ? getItemProps(options) : {}
  }, [getItemProps])
  
  return (
    <PerfectScrollbar
      options={{
        wheelPropagation: false,
      }}
      onYReachEnd={() => {
        if(items.length < 1 || !isOpen) return
        onScrollEnd && onScrollEnd()
      }}
      style={{
        ...menuStyle,
      }}
    >
      <ul
        {...menuProps}
        style={{
          display: 'flex',
          width: '100%',
          boxSizing: 'border-box',
          // zIndex: 100,
          padding: 0,
          flexDirection: 'column',
          margin: 0,
        }}
      >
        { items.map((item, i, arr) => (
          <li
            className="poll-combobox-item"
            style={{
              backgroundColor: highlightedIndex === i ? '#bde4ff' : undefined,
              color: item.disabled ? 'var(--slate10)' : undefined,
              cursor: item.disabled ? 'default' : undefined,
              fill: item.disabled ? 'var(--slate10)' : undefined
            }}
            key={`${item.name}-${i}`}
            {...itemPropsFunc({
              item,
              index: i,
              // isSelected: selectedItem && selectedItem.id === item.id, 
              disabled: typeof item.disabled === 'boolean' && item.disabled
            })}
          >
            {renderItem ? renderItem(item, i, arr) : item.name}
          </li>
        ))}
      </ul>
    </PerfectScrollbar>
  )
}

export default ScrollZone